import { JObject } from "../../../../common/data/models"
import { TopUpEligibleResultDto } from "../../domain"

export const TopUpEligibleResultMapper = {
    /**
     * Create cart model from json object
     * @param json
     * @returns {TopupPartnerDto}
     */
    toDto: (json: JObject, message: string): TopUpEligibleResultDto => {
        return {
            amount: json.amount,
            cashback: json.cashback,
            eligible: json.eligible,
            fees: json.fees,
            feesTax: json.feesTax,
            showOnBoard: json.showOnBoard,
            total: json.total,
            message: message
        }
    },
}
